/**
 * Feb-2026 (User-Wunsch 27.05.2026 — Refactoring P2) — Aus
 * `ListingDetailPage.jsx` ausgelagerte Fahrzeug-QR-Card.
 *
 * Sichtbarkeit:
 *   * QR-Code + Beschreibungstext — ALLE Besucher (auch B2C-Privatkunden).
 *   * Stand-Platz / Schlüssel-Nr. / Leitzahl — nur für Inserent / Händler / Admin.
 *   * „Druckbare QR-Karte öffnen" — nur für Inserent / Händler / Admin.
 *
 * Keine Verhaltens-Änderung gegenüber der ursprünglichen Inline-Sektion.
 */
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { QrCode } from "lucide-react";

export default function ListingQrCard({ listing, user }) {
    const isDealerLike = user?.role === "b2b" || user?.role === "admin" || user?.id === listing.owner_id;
    return (
        <div className="bg-white border border-gray-200 rounded-sm p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6" data-testid="listing-qr-section">
            <div className="bg-white p-3 border border-gray-200 rounded-sm shrink-0">
                <QRCodeSVG
                    value={`${(process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/+$/, "")}/listing/${listing.id}`}
                    size={140}
                    level="M"
                    includeMargin={false}
                    data-testid="listing-qr-code"
                />
            </div>
            <div>
                <h2 className="font-display text-2xl font-black mb-2 tracking-tight flex items-center gap-2">
                    <QrCode className="w-5 h-5 text-[#FFCC00]" /> Fahrzeug-QR-Code
                </h2>
                <p className="text-sm text-gray-700">
                    Scannen Sie diesen Code mit Ihrem Smartphone, um alle Fahrzeugdaten, Bilder und Kontaktdetails direkt aufzurufen — ideal für Schaufenster, Stand-Aushang oder Flyer.
                </p>
                {/* Stand-Platz / Schlüssel-Nr. / Leitzahl: nur intern */}
                {isDealerLike && listing.stand_platz && (
                    <p className="text-xs text-gray-500 mt-2">
                        Stand-Platz: <strong>{listing.stand_platz}</strong>
                        {listing.schluessel_nummer && <> · Schlüssel-Nr.: <strong>{listing.schluessel_nummer}</strong></>}
                        {(listing.key_depot || listing.leitzahl) && <> · Schlüsseldepot: <strong>{listing.key_depot || listing.leitzahl}</strong></>}
                    </p>
                )}
                {/* „Druckbare QR-Karte öffnen" — nur intern */}
                {isDealerLike && (
                    <Link
                        to={`/listing/${listing.id}/qrcard`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 mt-3 px-3 py-2 bg-[#111827] text-white text-xs font-bold uppercase tracking-wider rounded-sm hover:bg-black"
                        data-testid="open-qr-card"
                    >
                        <QrCode className="w-3.5 h-3.5" /> Druckbare QR-Karte öffnen
                    </Link>
                )}
            </div>
        </div>
    );
}
